<template>
  <div class="default-table items-table">
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="permissions.catalog.items.actions.new"
          v-on="on"
          @click.prevent="newDialog()"
          color="primary"
          class="mb-9"
          app
          fab
          bottom
          right
          fixed
        >
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.items.new.title }}</span>
    </v-tooltip>
    <Save
      v-if="dialog.selected"
      v-model="dialog.selected"
      :id="dialog.selected.id"
      :dialog="dialog.save"
      @closed="onCloseSave"
    />
    <DataTable
      name="items"
      :items="data"
      :tablehdrs="tableheaders.items"
      itemkey="cod"
      sortby="cat_id"
      groupby="parent_cat_name"
      :sortdesc="false"
    >
      <template v-slot:groupName="{ group }">
        {{ (group ? group : lang.categories.new.no_cat) }}
      </template>
      <template v-slot:default="{ item }">
        <tr
          :key="item.id"
          @dblclick="editDialog(item)"
          class="table-row item-row"
          :class="{ 'inactive': !(item.active) || item.inactive_cat }"
        >
          <td>
            <strong>{{ item.id }}</strong>
          </td>
          <td>
            <Thumb :photo="item.photo" :size="44" />
          </td>
          <td>{{ item.cod }}</td>
          <td class="datetime-col">
            {{ formatDate(item.created, true, true) }}
          </td>
          <td>
            <v-chip color="light-green" dark>
              {{ (item.cat > 0 && item.cat === item.parent_cat ? lang.categories.new.all : (item.cat > 0 ? item.cat_name : lang.categories.new.no_parent)) }}
            </v-chip>
          </td>
          <td>
            <v-tooltip top v-if="!(item.active)">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" small class="inactive-sign">
                  <v-icon small>mdi-cancel</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.items.status.inactive }}</span>
            </v-tooltip>
            {{ item.title }}
          </td>
          <!-- <td class="desc_col">
            <v-chip v-if="item.description" class="description" dark>{{ item.description }}</v-chip>
          </td> -->
          <td class="stock_col">
            <v-chip
              class="stock-chip"
              :color="getStock(item).color"
              dark
            >
              {{ getStock(item).title }}
            </v-chip>
          </td>
          <td>{{ formatCurrency(item.price) }}</td>
          <td class="actions-col">
            <Actions :value="item" @edit="editDialog" />
          </td>
        </tr>
      </template>
      <template v-slot:mobile="{ item }">
        <tr
          :key="`mb-${item.id}`"
          @dblclick="editDialog(item)"
          class="mobile_row table-row item-row"
          :class="{ 'inactive': !(item.active) }"
        >
          <td class="mobile_col">
          <ul class="flex-content pl-2">
            <li class="flex-item" :data-label="`${lang.items.datatable.headers.id}:`">{{ item.id }}</li>
            <li class="flex-item">
              <Thumb :photo="item.photo" :size="45" />
            </li>
            <li class="flex-item" :data-label="`${lang.items.datatable.headers.code}:`">{{ item.cod }}</li>
            <li class="flex-item" :data-label="`${lang.items.datatable.headers.subcategory}:`">
              <v-chip color="light-green" dark>
                {{ (item.cat > 0 && item.cat === item.parent_cat ? lang.categories.new.all : (item.cat > 0 ? item.cat_name : lang.categories.new.no_parent)) }}
              </v-chip>
            </li>
            <li class="flex-item" :data-label="`${lang.items.datatable.headers.title}:`">
              <v-tooltip top v-if="!(item.active)">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" small class="inactiveSign">
                    <v-icon small>mdi-cancel</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.items.status.inactive }}</span>
              </v-tooltip>
              {{ item.title }}
            </li>
            <li class="flex-item" :data-label="`${lang.items.datatable.headers.description}:`">
              <v-chip v-if="item.description" color="blue darken-1" class="description" dark>{{ item.description }}</v-chip>
            </li>
            <li class="flex-item" :data-label="`${lang.items.datatable.headers.price}:`">{{ formatCurrency(item.price) }}</li>
            <li class="flex-item actions-row" :data-label="lang.items.datatable.headers.action">
              <Actions :value="item" @edit="editDialog" />
            </li>
          </ul>
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import Thumb from './Thumb'
import Actions from './Actions'
import Save from '../Save'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import list from '@/mixins/defaults/list_subpage'

export default {
  components: { DataTable, Thumb, Actions, Save },
  mixins: [ appdata, utils, list ],
  data: () => ({
    default: { ...defaults.blank.item },
    pageName: 'items'
  }),
  computed: {
    data () {
      const catalog = this.get_data.catalog || []
      return catalog.filter(cat => cat.catalog === this.pageName) || []
    }
  },
  methods: {
    getStock (item) {
      let lang = this.lang.items.stock,
          title = (item.stock > 0 ? (item.qty > 0 ? lang.available(item.qty) : lang.unavailable ) : lang.disabled),
          color = (item.stock > 0 ? (item.qty > 0 ? 'green' : 'red' ) : 'grey')
      return { title, color }
    }
  }
}
</script>

<style src="../styles/list.scss" lang="scss"></style>
